/**
 * Bestsellers section — mobile carousel only.
 *
 * On mobile the product grid becomes a Swiper carousel; on desktop the Swiper
 * is destroyed so the CSS grid layout takes over. Card behavior (quick add,
 * add to cart) is owned entirely by the product card component.
 */
const MOBILE_QUERY = '(max-width: 767px)';

class LpBestsellers extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.mql = window.matchMedia(MOBILE_QUERY);
    this.handleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.swiperEl = this.querySelector('.lp-bs__grid.swiper');
    this.syncSwiper();
    this.mql.addEventListener('change', this.handleChange);
  }

  disconnectedCallback() {
    this.mql.removeEventListener('change', this.handleChange);
    this.destroySwiper();
  }

  handleChange() {
    this.syncSwiper();
    this.swiper?.update();
  }

  syncSwiper() {
    if (this.mql.matches) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  initSwiper() {
    if (!this.swiperEl || this.swiper) return;

    const SwiperClass = window.Swiper;
    if (typeof SwiperClass === 'undefined') {
      window.addEventListener('load', () => this.syncSwiper(), { once: true });
      return;
    }
    if (this.swiperEl.classList.contains('swiper-initialized')) return;

    const scrollbarEl = this.swiperEl.querySelector('.lp-bs__scrollbar');

    this.swiper = new SwiperClass(this.swiperEl, {
      slidesPerView: 1.46,
      spaceBetween: 16,
      freeMode: true,
      watchOverflow: true,
      scrollbar: scrollbarEl
        ? {
            el: scrollbarEl,
            hide: false,
          }
        : undefined,
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('lp-bestsellers')) {
  customElements.define('lp-bestsellers', LpBestsellers);
}
